import React from 'react';
import styled from 'styled-components';

export default function ScheduleModal({ onAppend, onReplace, onCancel, onClose }) {
  return (
    <ModalBackdrop>
      <ModalDialog role="dialog" aria-modal="true" aria-labelledby="unsaved-modal-title" aria-describedby="unsaved-modal-desc" tabIndex={-1}>
        <ModalHeader>
          <ModalTitle id="unsaved-modal-title">Unsaved Changes</ModalTitle>
          <CloseButton type="button" onClick={onClose} aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
              aria-hidden="true">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </CloseButton>
        </ModalHeader>
        <ModalDesc id="unsaved-modal-desc">
          You have unsaved changes. Please click the button below to proceed with your action.
        </ModalDesc>
        <ModalActions>
          <ActionGroup>
            <PrimaryButton onClick={onAppend}>Append</PrimaryButton>
            <PrimaryButton onClick={onReplace}>Replace</PrimaryButton>
          </ActionGroup>
          <CancelButton onClick={onCancel}>Cancel</CancelButton>
        </ModalActions>
      </ModalDialog>
    </ModalBackdrop>
  );
}

const ModalBackdrop = styled.div`
  position: fixed;
  z-index: 50;
  inset: 0;
  background: rgba(0,0,0,0.18);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalDialog = styled.div`
  position: relative;
  background: #fff;
  border-radius: 0.5rem;
  max-width: 32rem;
  width: 100%;
  padding: 1.5rem;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  display: grid;
  gap: 1.25rem;
  animation: fadeInZoom 0.2s;
  @keyframes fadeInZoom {
    from { opacity: 0; transform: scale(0.95);}
    to { opacity: 1; transform: scale(1);}
  }
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const ModalTitle = styled.h2`
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: var(--color-primary);
  border-radius: 0.25rem;
  padding: 0.25rem;
  cursor: pointer;
  transition: opacity 0.2s;
  position: absolute;
  top: 1rem;
  right: 1rem;
  &:hover {
    color: var(--color-secondary);
  }
  svg {
    width: 1.25rem;
    height: 1.25rem;
    display: block;
  }
`;

const ModalDesc = styled.p`
  font-size: 0.95rem;
  color: #var(--color-secondary-text);
  margin: 0.5rem 0 0 0;
`;

const ModalActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
  @media (max-width: 640px) {
    flex-direction: row;
    gap: 0.5rem;
  }
`;

const ActionGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const PrimaryButton = styled.button`
  background: #052959;
  color: #fff;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 1.25rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(16,24,40,0.08);
  transition: background 0.2s;
  &:hover {
    background: var(--color-secondary);
  }
`;

const CancelButton = styled.button`
  background: #052959
  color: #fff;
  font-size: 1rem;
  border: none;
  font-weight: 500;
  padding: 0.5rem 1.25rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(16,24,40,0.08);
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: var(--color-secondary);
  }
`;
